<template>
    <el-dialog v-model="dialogShow" title="编辑句子" width="550px" align-center="true" :before-close="handleClose" destroy-on-close>

        <div class="inrect vh-flex">
            <div class="dialog_lb">句子</div>
            <div class="mgt10">
                <input type="text" v-model="sentence" class="line_input" placeholder="请输入句子" />
            </div>
            <div class="dialog_lb mgt20">译文</div>
            <div class="mgt10">
                <input type="text" v-model="translate" class="line_input" placeholder="请输入翻译" />
            </div>
            <div class="dialog_lb mgt20">音标</div>
            <div class="mgt10">
                <input type="text" v-model="symbol" class="line_input" placeholder="请输入音标" />
            </div>
            <div class="vh-full"></div>
            <SaveButton @buttonClick="saveClick"></SaveButton>
        </div>
    </el-dialog>
</template>

<script>
import SaveButton from '@/components/SaveButton.vue'
import httpClient from '@/commom/http/httpClient'
export default {
    name: 'EditSentenceDialog',
    components: {
        SaveButton
    },
    props: {
        show: Boolean,
        sentenceItem: Object
    },
    watch: {
        show: function (nval, old) {
            this.dialogShow = nval
            if (nval) {
                this.loadSentence()
            }
        },

    },
    data() {
        return {
            dialogShow: this.showDialog,
            sentence: "",
            translate: "",
            symbol: ""
        }
    },
    mounted: function () {
        if (this.sentenceItem) {
            this.loadSentence()
        }
    },
    methods: {
        ///加载句子
        loadSentence: function () {
            this.sentence = this.sentenceItem.sentence
            this.translate = this.sentenceItem.translate
            this.symbol = this.sentenceItem.symbol
        },
        handleClose: function () {
            this.selectButton(false)
        },
        ///选择按钮
        selectButton: function (result, data) {
            var res = {
                confrim: result,
                data: data
            }
            this.$emit("selectButton", res)
        },
        saveClick: function (result) {
            if (!result) {
                this.selectButton(false)
                return
            }
            var sentence = this.sentence.trim()
            if (sentence.length == 0) {
                this.$message({ message: '请输入句子' })
                return
            }
            var model = {
                Sentence: sentence,
                Translate: this.translate,
                Symbol: this.symbol
            }
            var req = {
                sentenceId: this.sentenceItem.sentenceId,
                model: JSON.stringify(model)
            }
            var that = this
            httpClient.invoke("UnitSentenceAPI.UpdateSentence", req, function (res) {
                if (res.error) {
                    that.$message({ message: res.error })
                    return
                }
                if (!res.success) {
                    that.$message({ message: res.message })
                    return
                }

                that.selectButton(true, model)
            })
        },


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.inrect {
    height: 450px;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 15px;
}
</style>